import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n/LanguageContext";
import "../legal/legal.css";

function CommunityGuidelines() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isNe = lang === "ne";

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <button type="button" className="legal-back-btn" onClick={() => navigate(-1)}>
            {isNe ? "← फिर्ता" : "← Back"}
          </button>
          <h1 className="fw-bold mb-2">{isNe ? "समुदाय निर्देशिका" : "Community Guidelines"}</h1>
          <p className="mb-0 opacity-75">
            {isNe
              ? "नेपालभर सबैका लागि GharBhada लाई सुरक्षित, निष्पक्ष र विश्वासिलो बनाइराख्ने मापदण्डहरू।"
              : "Standards that keep GharBhada safe, fair, and trustworthy for everyone in Nepal."}
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "१. इमानदार रहनुहोस्" : "1. Be Honest"}</h2>
              <p>{isNe ? "सूचीमा फोटो, मूल्य, स्थान, आकार र सुविधाबारे सही जानकारी दिनुहोस्। भ्रमपूर्ण सूची हटाइन्छ र खाता निलम्बन हुन सक्छ।" : "Property listings must accurately represent the property — photos, price, location, size, and amenities must all be truthful. Misleading listings will be removed and accounts may be suspended."}</p>
              <p>{isNe ? "भाडा आवेदनमा व्यक्तिगत र रोजगार सम्बन्धी सही विवरण दिनु आवश्यक छ। जाली आवेदनमा स्थायी रूपमा प्लेटफर्मबाट हटाइनेछ।" : "Renters must provide accurate personal and employment information on rental applications. Fraudulent applications are grounds for permanent removal from the platform."}</p>
            </div>

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "२. सबैको सम्मान गर्नुहोस्" : "2. Respect Everyone"}</h2>
              <p>{isNe ? "भाडावाल र मालिकबीचको सबै संवाद सभ्य र व्यावसायिक हुनुपर्छ। जात, लिङ्ग, धर्म, समुदाय वा अपाङ्गतामा आधारित दुर्व्यवहार/भेदभाव स्वीकार्य छैन।" : "All communication between renters and owners must be respectful and professional. Harassment, threats, discrimination based on caste, gender, religion, ethnicity, or disability will not be tolerated."}</p>
              <p>{isNe ? "नेपालको कानुनले आवासीय भेदभाव निषेध गर्छ। यस्तो रिपोर्ट आएमा हामी कडाइका साथ छानबिन गरी कारबाही गर्छौं।" : "Nepal law prohibits discriminatory housing practices. GharBhada enforces this strictly — any report of discrimination will be investigated and actioned."}</p>
            </div>

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "३. ठगी वा जालसाजी नगर्नुहोस्" : "3. No Scams or Fraud"}</h2>
              <p>{isNe ? "सहमति भएको सर्तबाहिर पैसा नमाग्नुहोस्/नपठाउनुहोस्। लिखित सम्झौता अघि अनौपचारिक माध्यमबाट अग्रिम भुक्तानी नगर्नुहोस्।" : "Do not request or send money outside of agreed rental terms. Never ask for advance payments through unofficial channels (WhatsApp, cash to strangers, etc.) before a signed agreement."}</p>
              <p>{isNe ? <>शंकास्पद सन्देश वा नक्कली सूची भेटेमा तुरुन्त <a href="mailto:support@gharbhada.org">support@gharbhada.org</a> मा रिपोर्ट गर्नुहोस्। हामी सबै रिपोर्टको जाँच गर्छौं।</> : <>If you receive a suspicious message or believe a listing is fake, report it immediately to <a href="mailto:support@gharbhada.org">support@gharbhada.org</a>. We investigate all reports.</>}</p>
            </div>

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "४. गोपनीयता जोगाउनुहोस्" : "4. Protect Privacy"}</h2>
              <p>{isNe ? "अरू प्रयोगकर्ताको व्यक्तिगत जानकारी (फोन, ठेगाना, परिचयपत्र) तेस्रो पक्षसँग साझा नगर्नुहोस्। प्लेटफर्मबाट प्राप्त जानकारी केवल भाडा प्रयोजनका लागि हो।" : "Do not share another user's personal information (phone number, address, ID documents) with third parties. Information shared through the platform is for rental purposes only."}</p>
              <p>{isNe ? "GharBhada बाट प्राप्त सम्पर्क विवरण असम्बन्धित सेवा/बजारिकरणमा प्रयोग नगर्नुहोस्।" : "Do not use contact details gathered through GharBhada to market unrelated products or services."}</p>
            </div>

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "५. सूची अद्यावधिक राख्नुहोस्" : "5. Keep Listings Current"}</h2>
              <p>{isNe ? "मालिकले सूची सधैं अद्यावधिक राख्नुपर्छ। सम्पत्ति उपलब्ध नभए तुरुन्त सूची हटाउनुहोस् वा निष्क्रिय बनाउनुहोस्। पुराना/भ्रामक सूची चेतावनीपछि हटाइन्छन्।" : "Property owners are responsible for keeping their listings up to date. If a property is no longer available, remove or deactivate the listing immediately. Stale listings that waste renters' time will be flagged and removed after warning."}</p>
            </div>

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "६. प्रति व्यक्ति एक खाता" : "6. One Account Per Person"}</h2>
              <p>{isNe ? "प्रत्येक व्यक्ति वा संस्थाले एउटा मात्र खाता राख्न सक्छ। निलम्बन छल्न वा र्‍याङ्किङ प्रभाव पार्न डुप्लिकेट खाता बनाउनु निषेध छ र स्थायी हटाइ हुन सक्छ।" : "Each individual or business may maintain one account. Creating duplicate accounts to circumvent suspensions or manipulate rankings is prohibited and will result in permanent removal."}</p>
            </div>

            <div className="legal-card mb-4">
              <h2 className="legal-section-title">{isNe ? "७. उल्लंघन रिपोर्ट गर्नुहोस्" : "7. Reporting Violations"}</h2>
              <p>{isNe ? "यी निर्देशिका उल्लंघन गर्ने सामग्री वा व्यवहार देख्नुभयो भने हामीलाई रिपोर्ट गर्नुहोस्:" : "If you see content or behaviour that violates these guidelines, report it to us:"}</p>
              <ul>
                <li>Email: <a href="mailto:support@gharbhada.org">support@gharbhada.org</a></li>
                <li>{isNe ? "कुनै पनि सूची वा सन्देशमा रहेको Report बटन प्रयोग गर्नुहोस्" : "Use the Report button on any listing or message"}</li>
              </ul>
              <p>{isNe ? "हामी सबै रिपोर्ट समीक्षा गर्छौं र २ कार्यदिवसभित्र प्रतिक्रिया दिन्छौं।" : "We review all reports and respond within 2 business days."}</p>
            </div>

            <div className="legal-contact-box text-center">
              <h5 className="fw-bold mb-2">{isNe ? "यी निर्देशिकाबारे प्रश्न छन्?" : "Questions about these guidelines?"}</h5>
              <p className="text-muted mb-3">{isNe ? "माथिका कुनै पनि विषयमा हाम्रो टोली सहयोग गर्न तयार छ।" : "Our team is happy to clarify any of the above."}</p>
              <a href="mailto:support@gharbhada.org" className="btn btn-primary px-4"
                style={{ background: "var(--gb-primary)", borderColor: "var(--gb-primary)" }}>
                {isNe ? "सम्पर्क गर्नुहोस्" : "Contact Us"}
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default CommunityGuidelines;
